<template>
    <ModalComponent
        name="cerrando-butacas"
        title="Cerrando butacas"
        v-on:close="() => confirmar()"
    >
        <h3>Se están cerrando las butacas de los abonados, cuando se hayan cerrado recibirás una notificación</h3>
        <Button class="mt-2" @click="confirmar()">Aceptar</Button>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        methods: {
            confirmar() {
                this.$emit('confirmar', 'cerrando-butacas');
            }
        },
        components: {
            ModalComponent
        }
    }
</script>

